import _Spin from "@arco-design/web-react/es/Spin";
import React from 'react';
import Loadable from 'react-loadable';
function LoadingComponent(props) {
  if (props.error) {
    console.error(props.error);
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "spin-wrapper"
  }, /*#__PURE__*/React.createElement(_Spin, {
    style: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      fontSize: 30,
      transform: 'translate(-50%, -50%)'
    }
  }));
}
export default (function (loader, loadingComponent) {
  if (loadingComponent === void 0) {
    loadingComponent = LoadingComponent;
  }
  return Loadable({
    loader: loader,
    loading: loadingComponent
  });
});